import styled from "styled-components";

export const LegalTextWrapper = styled.div`
  display: none;
  @media print {
    display: block;
    font-size: ${({ theme }) => theme.font.size.sm};
    padding-top: 1rem;
    margin-top: 1rem;
    border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  }
`;
export const LegalTextContent = styled.p`
  font-size: ${({ theme }) => theme.font.size.xs};
  text-align: center;
  &:first-child {
    padding-top: 1rem;
  }
`;
